import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import _get from 'lodash/get';

const MIGRATED_VERSION:DesignerVersion = 21;

export const migration_20_21:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        designState.bindings = _get(designState, 'binding.runtime.bindings', {});
        delete designState.binding;

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
